<template lang="pug">
  y-dialog(v-model="showDialog" :fullscreen="$vuetify.breakpoint.xsOnly" max-width="600" persistent scrollable content-class="round-3xl")
    v-card(min-height="90vh")
      v-card-title.pa-4
        v-row(no-gutters align="center")
          v-col(cols="10" offset="1")
            div.text-xl.font-bold.neutral700--text.text-center {{ $t('reschedule_new_date') }}
          v-col(cols="1" align="right")
            v-btn.ml-n3(text icon @click="closeDialog")
              v-icon(color="neutral700" :size="24") mdi-close
      v-divider
      v-card-text(:class="$vuetify.breakpoint.xsOnly ? 'pa-4' : 'pa-8'")
        div.d-flex.justify-center.mt-16(v-if="isFetching")
          v-progress-circular(:width="2" :size="50" color="primary" indeterminate)

        template(v-else-if="appointment")
          div.text-sm.font-semibold.neutral500--text {{ $t('patient_detail') }}

          v-card.mt-4.pa-4.round-lg(outlined)
            v-row(no-gutters)
              v-col(cols="6")
                div.text-xs.neutral500--text {{ $t('name') }}
                div.text-sm.neutral700--text.mt-1 {{ appointment.lead.name || '-' }}
              v-col(cols="6")
                div.text-xs.neutral500--text {{ $t('nric_passport') }}
                div.text-sm.neutral700--text.mt-1 {{ appointment.lead.ic || '-' }}
              v-col.pt-4(cols="6")
                div.text-xs.neutral500--text {{ $t('service') }}
                div.text-sm.neutral700--text.mt-1 {{ appointment.service.name || '-' }}
              v-col.pt-4(cols="6")
                div.text-xs.neutral500--text {{ $t('doctor') }}
                div.text-sm.neutral700--text.mt-1 {{ appointment.provider.name || '-' }}

          div.text-md.font-semibold.neutral700--text.mt-6 {{ $t('change_appointment_date_time') }}

          div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('appointment_date') }}
          y-dialog(v-model='showPicker' width='320px')
            template(v-slot:activator='{ on }')
              v-text-field.text-sm.mt-2.round-xl(v-model="selectedDate" :placeholder="$t('select_appointment_date')" outlined :rules="rules.not_empty" hide-details="auto" v-on="on" :loading="isFetchingDates")
                template(v-slot:append)
                  eva-icon(name="calendar-outline" fill="#848484")
            v-card
              v-card-text.px-2.pt-2.pb-0
                div.d-flex.justify-center.align-center(v-if="isFetchingDates" style="height: 380px;")
                  v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
                yc-date-picker(v-else :parentDate.sync="form.date" color="info" :allowedDates="unavailableDateList" :minDate="getTodayDate()" :parentPickerDate.sync="pickerDate")
              v-card-actions.px-4.pb-4
                v-row(no-gutters)
                  v-col.pr-2
                    v-btn.round-lg.heading-6(color="basic700" block dark outlined depressed @click="clearDate") {{ $t('clear') }}
                  v-col.pl-2
                    v-btn.round-lg.heading-6(color="info500" block dark depressed :dark="Boolean(form.date)" :disabled="!form.date" @click="pickDate(appointment.service.id, appointment.provider.id, form.date)") {{ $t('select') }}

          div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('available_time') }}
          y-select.mt-2(v-model="form.time" :items="times" item-text="text" item-value="value" :placeholder="$t('select_available_time')" :rules="rules.not_empty_select" :loading="isFetchingTimes" no-data-text="No timeslot available")

      v-divider
      v-card-actions.py-4(:class="$vuetify.breakpoint.xsOnly ? 'px-4' : 'px-8'")
        v-btn.button-md.neutral700--text.px-0(@click="closeDialog" text) {{ $t('cancel') }}
        v-spacer
        v-btn.button-md(:loading="isLoading" color="neutral700" depressed dark @click="confirmAction") {{ $t('confirm') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'RescheduleDate',
  components: {},
  props: ['open', 'selectedAppointment'],
  data () {
    return {
      isFetching: false,
      isFetchingDates: false,
      isFetchingTimes: false,
      isLoading: false,
      showPicker: false,
      appointment: null,
      selectedDate: null,
      pickerDate: null,
      form: {},
      unavailableDates: [],
      times: [],
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    }
  },
  watch: {
    pickerDate (val) {
      if (this.appointment) {
        this.fetchUnavailableDates(this.appointment.provider.id, val)
      }
    }
  },
  mounted () {
    this.fetchAppointment()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchAppointment () {
      this.isFetching = true
      this.$axios.get(`/clinics/${this.company.slug}/appointments/${this.selectedAppointment.id}`)
        .then(resp => {
          this.appointment = resp.data
          this.form = {
            date: this.appointment.date,
            time: this.appointment.time
          }
          this.selectedDate = this.$options.filters.humanizeDate(this.appointment.date)
          this.fetchUnavailableDates(this.appointment.provider.id)
          this.fetchTimes(this.appointment.service.id, this.appointment.provider.id, this.appointment.date)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchUnavailableDates (provider, yearMonth) {
      this.isFetchingDates = true
      let params = {}
      if (yearMonth) {
        params.year = yearMonth.substr(0, 4),
        params.month = yearMonth.substr(-2)
      }
      this.$axios.get(`/clinics/${this.company.slug}/providers/${provider}/leave_dates`, { params })
        .then(resp => {
          this.unavailableDates = resp.data
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetchingDates = false
        })
    },
    fetchTimes (service, provider, date) {
      this.isFetchingTimes = true
      this.$axios.get(`/clinics/${this.company.slug}/providers/${provider}/available_times?service=${service}&date=${date}&reschedule_id=${this.selectedAppointment.id}`)
        .then(resp => {
          this.times = resp.data.times.map(m => { return { text: this.$options.filters.displayTime2(m), value: m }})
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isFetchingTimes = false
        })
    },
    unavailableDateList (val) {
      if (this.unavailableDates.includes(val)) {
        return false
      }
      return true
    },
    pickDate (service, provider, date) {
      this.selectedDate = this.$options.filters.humanizeDate(this.form.date)
      this.showPicker = false
      !this.form.time || this.$set(this.form, 'time', null)
      this.fetchTimes(service, provider, date)
    },
    confirmAction () {
      this.isLoading = true
      const data = {
        service: this.appointment.service.id,
        provider: this.appointment.provider.id,
        start: `${this.form.date} ${this.form.time}`
        // date: this.form.date,
        // time: this.form.time
      }
      this.$axios.patch(`/clinics/${this.company.slug}/appointments/${this.selectedAppointment.id}`, data)
        .then(() => {
          this.closeResetDialog()
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    clearDate () {
      this.form.date = null
      this.selectedDate = null
      this.showPicker = false
    },
    closeResetDialog () {
      this.showDialog = false
      this.$emit('reset')
    },
    closeDialog () {
      this.showDialog = false
      this.$emit('closed')
    },
    getTodayDate () {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>